// src/fontawesome.js

import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faEdit, 
  faTimes, 
  faBell, 
  faFilter, 
  faEye,
  faEyeSlash, 
  faSpinner, 
  faChartBar, 
  faTable, 
  faClock, 
  faExclamationTriangle, 
  faPauseCircle, 
  faRedo, 
  faCheck,
  faCheckCircle, 
  faArrowRight, 
  faTimesCircle 
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faEdit, 
  faTimes, 
  faBell, 
  faFilter, 
  faEye,
  faEyeSlash, 
  faSpinner, 
  faChartBar, 
  faTable, 
  faClock, 
  faExclamationTriangle, 
  faPauseCircle, 
  faRedo, 
  faCheck,
  faCheckCircle, 
  faArrowRight, 
  faTimesCircle
);

export { FontAwesomeIcon };
